import React, { useEffect } from 'react';
import './OAuth.scss';
import { connect } from 'react-redux';
import { athleticTrainerSignUpWithOAuth, googleLogin } from 'redux/ducks/Session';
import googleIcon from '../../images/google-logo.png';
import { ORGANIZATION_TYPES_REGISTRATION } from 'helpers/enums';
import { loadGoogleAdsFromLocalStorage, getReferralCode } from '@helpers/localStorage';
import { withRouter } from 'react-router-dom';

const Google = ({ onGoogleLogin, userType, onAthleticTrainerGoogleLogin, history, step }) => {
  useEffect(() => {
    // Load Google Identity Services script
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    script.onload = () => {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          callback: handleCredentialResponse,
          auto_select: false,
          cancel_on_tap_outside: true,
        });
      }
    };

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  const handleCredentialResponse = response => {
    console.warn({ response });

    try {
      // The response contains the JWT credential that can be validated on the backend
      const { credential } = response;

      if (credential) {
        // Pass the JWT credential to the backend for validation

        if (userType === 'AthleticTrainer') {
          onAthleticTrainerGoogleLogin({
            credential,
            history,
          });
        } else {
          const credentials = {
            credential,
            user_data: {
              default_event_setting_id:
                ORGANIZATION_TYPES_REGISTRATION[localStorage.getItem('registrationOrgType')],
              ...loadGoogleAdsFromLocalStorage(),
              ...(getReferralCode() && { referral: getReferralCode() }),
            },
          };

          onGoogleLogin(credentials, history, step);
        }
      } else {
        console.error('No credential received from Google');
      }
    } catch (error) {
      console.error('Error processing Google login:', error);
    }
  };

  const handleCustomButtonClick = () => {
    if (window.google && window.google.accounts) {
      // Create a temporary button to trigger Google Sign-In
      const tempButton = document.createElement('div');
      tempButton.style.display = 'none';
      document.body.appendChild(tempButton);

      window.google.accounts.id.renderButton(tempButton, {
        theme: 'outline',
        size: 'large',
        type: 'standard',
        text: 'signin_with',
        shape: 'rectangular',
        logo_alignment: 'left',
      });

      const googleButton = tempButton.querySelector('div[role="button"]');
      if (googleButton) {
        googleButton.click();
      }

      setTimeout(() => {
        document.body.removeChild(tempButton);
      }, 100);
    }
  };

  return (
    <div className="google-login">
      <button className="google-login-button" onClick={handleCustomButtonClick}>
        <img src={googleIcon} alt="Google" className="google-icon" />
        <span>Sign in with Google</span>
      </button>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  onGoogleLogin: (credentials, history, step) => dispatch(googleLogin({ credentials, history, step })),
  onAthleticTrainerGoogleLogin: credentials => dispatch(athleticTrainerSignUpWithOAuth(credentials)),
});

export default withRouter(connect(null, mapDispatchToProps)(Google));
